export default __webpack_public_path__ + "static/media/banner-right.024bc64d.png";